import { useTranslation } from 'react-i18next';

export const getSpeedColor = (speedPercentile) => {
    if (speedPercentile >= 0.88) return '#FF0000';
    if (speedPercentile >= 0.78) return '#254C75';

    return '#0077D9';
};

export const useFormatSpeed = () => {
    const { t } = useTranslation();

    const formatSpeed = (speed, showMph) => {
        if (!speed) return '-';

        return showMph ? t('format.abbr-mph', { value: (speed * 0.681818).toFixed(1) }) : t('format.abbr-fts', { value: speed.toFixed(1) });
    };

    return { formatSpeed };
};
